import { BitkitAlert, useResponsive } from '@bitrise/bitkit-v2';
import { Box } from '@chakra-ui/react/box';

import { PAGE_HEADER_STICKY_HEIGHT } from '@/components/page/PageHeader/StickyPageHeader';
import { HEADER_HEIGHT } from '@/constants';

type SwitchToStructuredLogAlertProps = {
  padding: number;
  onClose: VoidFunction;
};

const SwitchToStructuredLogAlert = ({ onClose, padding }: SwitchToStructuredLogAlertProps) => {
  const { isMobile } = useResponsive();
  // The stuck header's height, which is static -- no measuring, so none of the delay that kept a
  // hard-coded 64 here. That 64 was the old header's stuck row; the current one is taller.
  const pageHeaderHeight = isMobile ? 0 : PAGE_HEADER_STICKY_HEIGHT;
  const offset = pageHeaderHeight + HEADER_HEIGHT + padding;

  const handleSwitch = () => {
    window.location.reload();
  };

  return (
    <Box
      display="flex"
      justifyContent="space-around"
      left="0"
      margin="auto"
      height="0"
      right="0"
      zIndex="1"
      position="sticky"
      top={offset}
    >
      <BitkitAlert
        variant="info"
        position="absolute"
        action={{
          label: 'Switch to structured view',
          onClick: handleSwitch,
        }}
        dismissible
        onClose={onClose}
        width="initial"
        messageText="The structured view of this log is ready"
      />
    </Box>
  );
};

export default SwitchToStructuredLogAlert;
